export default __webpack_public_path__ + "static/Tiles-large6-56d8a9a84e416dd5b02366366769e108.png";